import { useAuth } from '@/domains/auth/authProvider';

import { type PerspectiveColor, colorForPerspective } from './perspectiveColor';

/**
 * Theme color for the logged-in user's active perspective.
 * Falls back to 'primary' when there is no user, no active perspective,
 * or an unknown perspective name.
 */
export function usePerspectiveColor(): PerspectiveColor {
  const { user } = useAuth();
  return colorForPerspective(user?.activePerspective?.name);
}
